import { refreshToken } from '../../../middlewares/renew-ks';
import { RhinoError } from '../../error';

export function handleCloudFrontErrors(error: Error) {
  if (error instanceof RhinoError && (error.context?.response as Response)?.status === 401) {
    refreshToken();
    throw new RhinoError('EXPIRED_KS', undefined, error.context);
  }
  throw error;
}
